module.exports = __webpack_public_path__ + "static/img/m5.c8afa85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m5.png
// module id = CAMk
// module chunks = 12